import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = { class: "report" };
export default /*#__PURE__*/ _defineComponent({
    __name: 'ReportButton',
    props: {
        title: String,
        linkReport: String,
    },
    emits: ["openModal", "preview"],
    setup: function (__props, _a) {
        var emit = _a.emit;
        var props = __props;
        return function (_ctx, _cache) {
            var _component_font_awesome_icon = _resolveComponent("font-awesome-icon");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("a", {
                    onClick: _cache[0] || (_cache[0] = function ($event) { return (emit('preview')); }),
                    target: "_blank",
                    style: { "margin-right": "15px" }
                }, [
                    _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-eye" })
                ]),
                _createElementVNode("a", {
                    onClick: _cache[1] || (_cache[1] = function ($event) { return (emit('openModal')); }),
                    style: { "margin-right": "15px" }
                }, [
                    _createVNode(_component_font_awesome_icon, {
                        icon: "fa-solid fa-download",
                        style: { "margin-right": "15px" }
                    }),
                    _createElementVNode("span", null, _toDisplayString(__props.title), 1)
                ])
            ]));
        };
    }
});
